import { TrophyOutlined } from '@ant-design/icons';
import { CheckBox } from '@tmov/design-system';
import React from 'react';

import { getDataHorasFomatada } from '../../../../helpers/data-fns';
import {
  formatarMoeda,
  formatarTonelada,
  limitarLabel,
  toTitleCase,
} from '../../../../helpers/formatador';
import StatusCotacaoEnum from '../../Enum/StatusCotacaoEnum';

const getCheckBoxWidget = (value, record, handleOnChange) => {
  const component = (
    <CheckBox
      checked={value}
      updateChecked={checked => handleOnChange(checked, record.id)}
    />
  );

  return component;
};

const getTrophyIcon = aprovada => {
  let component = '';
  if (aprovada === true) {
    component = <TrophyOutlined style={{ color: '#24A95D' }} />;
  }

  return component;
};

export const getColumns = (
  handleOnChange,
  cotacaoStatus,
  cotacaoValorFinal
) => {
  const columns = [
    {
      header: 'Transportadora',
      accessor: 'razao_social',
      format: value => limitarLabel(toTitleCase(value), 30),
      rowSize: '24%',
    },
    {
      header: 'Data',
      accessor: 'created_at',
      format: value => getDataHorasFomatada(value),
      rowSize: '19%',
    },
    {
      header: 'Volume (ton)',
      accessor: 'volume',
      format: value => formatarTonelada(value),
      rowSize: '19%',
    },
    {
      header: 'Lance',
      accessor: 'valor_lance',
      format: value => formatarMoeda(value),
      rowSize: '19%',
    },
    cotacaoStatus === StatusCotacaoEnum.ENCERRADO &&
      cotacaoValorFinal === null && {
        header: '',
        accessor: 'aprovada',
        format: (aprovada, record) =>
          getCheckBoxWidget(aprovada, record, handleOnChange),
        rowSize: '5%',
      },
    cotacaoStatus === StatusCotacaoEnum.ENCERRADO &&
      cotacaoValorFinal !== null && {
        header: '',
        accessor: 'aprovada',
        format: aprovada => getTrophyIcon(aprovada),
        rowSize: '8%',
      },
  ].filter(Boolean);

  return columns;
};
